import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';

export default {
  ...cloneDeep(baseDefaults),
  mp4: 'https://res.cloudinary.com/ditbeukyz/video/upload/v1603906707/Resources/video_b51tlt.mp4',
  ratio: '1/1',
  muted: true,
};
